module.exports = __webpack_public_path__ + "static/works-one-6789832cc5eb7490d5bd65e539041e5c.svg";